export default '/build/4a5b33ab.svg'